import React from 'react';
import { connect } from 'react-redux';
import { showHidePopup } from './redux';

const WithPopup = Popup => {
  class WithPopupHoc extends React.Component {
    componentDidMount() {}

    showHide = isVisible => {
      this.props.showHidePopup(isVisible);
      /* const WithPopupEvent = new CustomEvent(
        'onPopupViewToggle',
        {
          data: {
            isVisible,
          },
        },
      );
      window.dispatchEvent(WithPopupEvent); */
    };

    render() {
      return <Popup {...this.props} onShowHideCallback={this.showHide} />;
    }
  }

  const mapStateToProps = state => ({
    isVisible: state.WithPopup?.isVisible,
  });

  const mapDispatchToProps = dispatch => ({
    showHidePopup: isVisible => {
      dispatch(showHidePopup(isVisible));
    },
  });

  return connect(mapStateToProps, mapDispatchToProps)(WithPopupHoc);
};

export default WithPopup;
